import React from 'react';
import { BookOpen, Calculator, Gauge, Hourglass, RefreshCw, Scale, Users } from 'lucide-react';

/* Pictogramme d'une fiche (2026-09-16) : chaque fiche porte le sien
   (`icon` dans data/savoirs.js), teinté par catégorie ; un livre répété sur
   chaque ligne ne distinguait rien. */
const ICONS = { hourglass: Hourglass, gauge: Gauge, calculator: Calculator, refresh: RefreshCw, scale: Scale, users: Users };

export default function FicheIcon({ fiche, size = 15 }) {
  const Ic = (fiche && ICONS[fiche.icon]) || BookOpen;
  const cat = String(fiche?.category || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  return (
    <span className={`kd-fic kd-fic--${cat}`} aria-hidden="true">
      <Ic size={size} strokeWidth={1.7} />
    </span>
  );
}
